import React from "react";

interface ConfigSectionProps {
  wsURL: string;
  setWsURL: (url: string) => void;
  authToken: string;
  setAuthToken: (token: string) => void;
  deviceID: string;
  setDeviceID: (id: string) => void;
  shardId: string;
  setShardId: (id: string) => void;
  eventType: string;
  setEventType: (type: string) => void;
  txAddress: string;
  setTxAddress: (address: string) => void;
  txHash: string;
  setTxHash: (hash: string) => void;
  txTypes: string;
  setTxTypes: (types: string) => void;
  txEventTypes: string;
  setTxEventTypes: (types: string) => void;
}

export const ConfigSection: React.FC<ConfigSectionProps> = ({
  wsURL,
  setWsURL,
  authToken,
  setAuthToken,
  deviceID,
  setDeviceID,
  shardId,
  setShardId,
  eventType,
  setEventType,
  txAddress,
  setTxAddress,
  txHash,
  setTxHash,
  txTypes,
  setTxTypes,
  txEventTypes,
  setTxEventTypes,
}) => {
  return (
    <div className="config-section">
      <h3>Configuration</h3>
      <div className="config-grid">
        <div className="config-item">
          <label htmlFor="ws-url">WebSocket URL</label>
          <input
            id="ws-url"
            type="text"
            value={wsURL}
            onChange={(e) => setWsURL(e.target.value)}
            placeholder="ws://localhost:8080/ws"
          />
        </div>
        <div className="config-item">
          <label htmlFor="auth-token">Auth Token (optional)</label>
          <input
            id="auth-token"
            type="text"
            value={authToken}
            onChange={(e) => setAuthToken(e.target.value)}
            placeholder="JWT token"
          />
        </div>
        <div className="config-item">
          <label htmlFor="device-id">Device ID</label>
          <input
            id="device-id"
            type="text"
            value={deviceID}
            onChange={(e) => setDeviceID(e.target.value)}
            placeholder="device-id"
          />
        </div>
        <div className="config-item">
          <label htmlFor="shard-id">Shard ID (optional filter)</label>
          <input
            id="shard-id"
            type="text"
            value={shardId}
            onChange={(e) => setShardId(e.target.value)}
            placeholder="e.g., 1, 2, 3"
          />
        </div>
        <div className="config-item">
          <label htmlFor="event-type">Event Type (optional filter for consensus_flat)</label>
          <input
            id="event-type"
            type="text"
            value={eventType}
            onChange={(e) => setEventType(e.target.value)}
            placeholder="e.g., new_vertex, new_tx, validator_update"
          />
        </div>
      </div>
      <div className="config-section-divider">
        <h4>Transaction Channel Filters</h4>
        <div className="config-grid">
          <div className="config-item">
            <label htmlFor="tx-address">Address (optional filter)</label>
            <input
              id="tx-address"
              type="text"
              value={txAddress}
              onChange={(e) => setTxAddress(e.target.value)}
              placeholder="0x..."
            />
          </div>
          <div className="config-item">
            <label htmlFor="tx-hash">Transaction Hash (optional filter)</label>
            <input
              id="tx-hash"
              type="text"
              value={txHash}
              onChange={(e) => setTxHash(e.target.value)}
              placeholder="0x..."
            />
          </div>
          <div className="config-item">
            <label htmlFor="tx-types">Transaction Types (optional filter)</label>
            <input
              id="tx-types"
              type="text"
              value={txTypes}
              onChange={(e) => setTxTypes(e.target.value)}
              placeholder="e.g., order, transfer, deposit (comma-separated)"
            />
          </div>
          <div className="config-item">
            <label htmlFor="tx-event-types">Event Types (optional filter)</label>
            <input
              id="tx-event-types"
              type="text"
              value={txEventTypes}
              onChange={(e) => setTxEventTypes(e.target.value)}
              placeholder="e.g., new_tx, tx_confirmed (comma-separated)"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

